import request from '@/utils/request'

export function fetchList(query) {
  return request({
    url: '/ContentData/GetPaging',
    method: 'get',
    params: query
  })
}
export function getTableSet(tableId) {
  return request({
    url: '/ContentData/GetTable',
    method: 'get',
    params: { tableId }
  })
}

export function fetchDetail(tableId, id) {
  return request({
    url: '/ContentData/Get',
    method: 'get',
    params: { tableId, id }
  })
}

export function createEntity(data) {
  return request({
    url: '/ContentData/Post',
    method: 'post',
    data
  })
}

export function updateEntity(data) {
  return request({
    url: '/ContentData/Put',
    method: 'post',
    data
  })
}
export function deleteEntity(tableId, ids) {
  return request({
    url: '/ContentData/Delete',
    method: 'get',
    params: { tableId, ids }
  })
}
export function fetchInitFormSet(tableId, id, sid) {
  return request({
    url: '/ContentData/InitFormSet',
    method: 'get',
    params: { tableId, id, sid }
  })
}

export function getAllList(query) {
  return request({
    url: '/ContentData/GetAllList',
    method: 'get',
    params: query
  })
}
export function getModel(query) {
  return request({
    url: '/ContentData/GetModel',
    method: 'get',
    params: query
  })
}

export function createMajor(data) {
  return request({
    url: '/ContentData/CreateMajor',
    method: 'post',
    data
  })
}

export function batchCreateEntity(data) {
  return request({
    url: '/ContentData/BatchInsert',
    method: 'post',
    data
  })
}

export function fetchInitViewSet(tableId, id, sid) {
  return request({
    url: '/ContentData/View',
    method: 'get',
    params: { tableId, id, sid }
  })
}

export function getExportTemplate(templateName) {
  const params = { templateName }
  return request.get(
    '/Business/ExportTemplate', { params }
  )
}

export function getConvertText(optionCode, optinValue, optionText, strValue) {
  return request({
    url: '/ContentData/GetConvertText',
    method: 'get',
    params: { optionCode, optinValue, optionText, strValue }
  })
}

export function getCheckdItem(optionCode, optinValue, optionText, strValue) {
  return request({
    url: '/ContentData/GetCheckdItem',
    method: 'get',
    params: { optionCode, optinValue, optionText, strValue }
  })
}

export function getSelectTreeList(optionCode, optinValue, optionText) {
  return request({
    url: '/ContentData/GetSelectTreeList',
    method: 'get',
    params: { optionCode, optinValue, optionText }
  })
}

export function addEntity(data) {
  return request({
    url: '/ContentData/Create',
    method: 'post',
    data
  })
}
